import Vue from "vue"
import Vuex from "vuex"
import auth from "./modules/auth"
import pmse from "./modules/pmse"
import mega_menu from "./modules/mega_menu"
import VuexPersistence from "vuex-persist"

const vuexLocal = new VuexPersistence({
  storage: window.localStorage,
})

Vue.use(Vuex)

export default new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  getters: {
    counter_value: (state) => {
      return state.counter
    },
  },
  modules: {
    auth: auth,
    mega_menu: mega_menu,
    pmse: pmse,
  },
  plugins: [vuexLocal.plugin],
})
